import React from 'react'
import { connect } from 'react-redux'
import {
  LIST_VIEW_ALL_SITES,
  LIST_VIEW_BARRIOS,
  LIST_VIEW_MY_SITES,
  FILTER_MAP_VIEW,
  FILTER_LIST_VIEW,
} from 'helpers/seaLice'
import AllSitesMap from './ContentGroups/AllSitesMap'
import AllSitesList from './ContentGroups/AllSitesList'
import MySitesMap from './ContentGroups/MySitesMap'
import MySitesWidget from './ContentGroups/MySitesWidget'
import BarriosMap from './ContentGroups/BarriosMap'
import BarriosWidgets from './ContentGroups/BarriosWidgets'

const compositionList = {
  [`${LIST_VIEW_ALL_SITES}+${FILTER_MAP_VIEW}`]: AllSitesMap,
  [`${LIST_VIEW_ALL_SITES}+${FILTER_LIST_VIEW}`]: AllSitesList,
  [`${LIST_VIEW_BARRIOS}+${FILTER_MAP_VIEW}`]: BarriosMap,
  [`${LIST_VIEW_BARRIOS}+${FILTER_LIST_VIEW}`]: BarriosWidgets,
  [`${LIST_VIEW_MY_SITES}+${FILTER_MAP_VIEW}`]: MySitesMap,
  [`${LIST_VIEW_MY_SITES}+${FILTER_LIST_VIEW}`]: MySitesWidget,
}

function SLContent(props) {
  const { activeView, activeMap } = props
  const compositionKey = `${activeView}+${activeMap}`
  const ComponentGroup = compositionList.hasOwnProperty(compositionKey)
    ? compositionList[compositionKey]
    : null

  return <ComponentGroup />
}

export default connect(
  state => ({
    activeMap: state.getIn(['seaLice', 'activeMap']),
  }),
  null,
)(SLContent)
